import Logo from "../../images/sidebar/Logo.svg";
import Avatar from "../../images/sidebar/avatar.png";
import classes from "./Sidebar.module.css";
import VehicleIcon from "../../images/sidebar/vehicleBlack.svg";
import DriversIcon from "../../images/sidebar/driversIcon.svg";
import DashboardIcon from "../../images/sidebar/dashboardIcon.svg";
import AddressesIcon from "../../images/sidebar/addressesIcon.svg";
import DeliveriesIcon from "../../images/sidebar/deliveriesIcon.svg";
import DriversIconBlack from "../../images/sidebar/driversIconBlack.svg";
import IntegrationsIcon from "../../images/sidebar/integrationsIcon.svg";
import VehicleBlackIcon from "../../images/sidebar/vehicleIcon.svg";
import DashboardIconBlack from "../../images/sidebar/dashboardIconBlack.svg";
import AddressesIconBlack from "../../images/sidebar/addressesIconBlack.svg";
import DeliveriesIconBlack from "../../images/sidebar/deliveriesIconBlack.svg";
import IntegrationsIconBlack from "../../images/sidebar/integrationsIconBlack.svg";
import { useEffect } from "react";
import { persistor } from "../../store";
import { LogOutIcon } from "../../images/sidebar/logOutIcon";
import { SidebarBtn } from "../buttons/sidebarBtn/SidebarBtn";
import { useNavigate } from "react-router-dom";
import { fetchAvatar } from "../../redux/auth/thunks/userThunk";
import { setSearchQuery } from "../../redux/misc/slices/searchSlice";
import { useTranslations } from "../../helperFunctions/customHooks/useTranslations";
import { resetVehicleForm } from "../../redux/forms/vehicleForm";
import { useDispatch, useSelector } from "react-redux";
import {
  toggleDashboard,
  toggleAddresses,
  toggleDeliveries,
  toggleDrivers,
  setShowThreeDotsModal,
  toggleIntegrations,
  toggleVehicles,
  setIsEditMode,
} from "../../redux/globalFunctions/globalFnSlice";

export function Sidebar() {
  const { isActiveSidebarBtn } = useSelector((state) => state.global);
  const firstname = useSelector((state) => state.user.firstname);
  const fetchedAvatar = useSelector((state) => state.user.avatarBlob);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslations();
  const sidebarText = t.sidebar;

  useEffect(() => {
    dispatch(fetchAvatar());
  }, [dispatch]);

  function logOut() {
    dispatch({ type: "RESET_STORE" });
    persistor.purge();
    setHeaderSearchQuery("");
    if (window.location.pathname !== "/login") {
      navigate("/login");
    }
  }

  function handleNavigation(path) {
    dispatch(setSearchQuery(""));
    setHeaderSearchQuery("");
    navigate(path);
  }

  function setHeaderSearchQuery(query) {
    const searchInput = document.getElementById("search");
    if (searchInput) {
      searchInput.value = query;
    }
  }

  // Helper to handle shared sidebar button behavior
  function handleSidebarClick(toggleAction, path) {
    dispatch(toggleAction());
    handleNavigation(path);
    dispatch(setShowThreeDotsModal(false));
    dispatch(setIsEditMode(false));
    dispatch(resetVehicleForm());
  }

  const sidebarButtons = [
    {
      key: "dashboard",
      label: sidebarText.dashboard,
      icon: DashboardIcon,
      activeIcon: DashboardIconBlack,
      path: "/dashboard",
      toggleAction: toggleDashboard,
    },
    {
      key: "deliveries",
      label: sidebarText.deliveries,
      icon: DeliveriesIcon,
      activeIcon: DeliveriesIconBlack,
      path: "/deliveries",
      toggleAction: toggleDeliveries,
      btnClass: "deliveriesBtn",
    },
    {
      key: "drivers",
      label: sidebarText.drivers,
      icon: DriversIcon,
      activeIcon: DriversIconBlack,
      path: "/drivers",
      toggleAction: toggleDrivers,
      btnClass: "driversBtn",
    },
    {
      key: "addresses",
      label: sidebarText.locations,
      icon: AddressesIcon,
      activeIcon: AddressesIconBlack,
      path: "/addresses",
      toggleAction: toggleAddresses,
      btnClass: "addressesBtn",
    },
    {
      key: "vehicles",
      label: sidebarText.vehicles,
      icon: VehicleBlackIcon,
      activeIcon: VehicleIcon,
      path: "/vehicles",
      toggleAction: toggleVehicles,
      btnClass: "vehiclesBtn",
    },
    {
      key: "integrations",
      label: sidebarText.integrations,
      icon: IntegrationsIcon,
      activeIcon: IntegrationsIconBlack,
      path: "/integrations",
      toggleAction: toggleIntegrations,
      btnClass: "integrationsBtn",
    },
  ];

  return (
    <section className={classes.sidebar}>
      <div className={`${classes.logo} fadeInTranslate`}>
        <img src={Logo} alt={sidebarText.logoAlt} />
      </div>

      <div className={`${classes.menu} fadeInTranslate `}>
        <div className={classes.buttons}>
          {sidebarButtons.map((btn) => (
            <SidebarBtn
              key={btn.key}
              isActive={isActiveSidebarBtn === btn.key}
              icon={btn.icon}
              activeIcon={btn.activeIcon}
              label={btn.label}
              btnClass={btn.btnClass}
              onClick={() => handleSidebarClick(btn.toggleAction, btn.path)}
            />
          ))}
        </div>
      </div>

      <div className={`${classes.username} fadeIn`}>
        <div className={classes.avatar}>
          <div className={classes.avatarImgDiv}>
            <img
              src={fetchedAvatar || Avatar}
              alt={sidebarText.avatarIconAlt}
            />
            <span>{firstname}</span>
          </div>
          <LogOutIcon onClick={logOut} />
        </div>
      </div>
    </section>
  );
}
